import React from 'react';

function fmt(iso) {
  return new Date(iso).toLocaleTimeString('ru-RU', { hour:'2-digit', minute:'2-digit' });
}

export default function SongCard({ song, index, isDj, showRank, onLike, onDelete, onTogglePlayed }) {
  return (
    <div className={`song-card ${song.played ? 'played' : ''} ${song.myRequest ? 'my-song' : ''}`}>
      {showRank && (
        <span className={`song-rank ${index < 3 ? 'top' : ''}`}>
          {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : index + 1}
        </span>
      )}

      <div className="song-info">
        <div className="song-title">{song.title}</div>
        <div className="song-meta">
          <span>{fmt(song.createdAt)}</span>
          {song.played    && <span className="badge badge-green">✓ Воспроизведено</span>}
          {song.myRequest && !song.played && <span className="badge badge-purple">Мой запрос</span>}
        </div>
      </div>

      <div className="song-actions">
        {/* Like — only guests on pending songs */}
        {!isDj && !song.played && (
          <button className={`like-btn ${song.likedByMe ? 'liked' : ''}`} onClick={() => onLike(song.id)}>
            {song.likedByMe ? '♥' : '♡'}
            {song.likesCount > 0 && <span>{song.likesCount}</span>}
          </button>
        )}

        {/* Likes display (read-only) for DJ or played songs */}
        {(isDj || song.played) && song.likesCount > 0 && (
          <span className="likes-count">♥ {song.likesCount}</span>
        )}

        {/* DJ played toggle */}
        {isDj && (
          <button
            className={`played-btn ${song.played ? 'is-played' : ''}`}
            onClick={() => onTogglePlayed(song.id, song.played)}
          >
            {song.played ? '↩ Вернуть' : '✓ Воспроизведено'}
          </button>
        )}

        {/* Delete */}
        {(song.myRequest || isDj) && (
          <button className="delete-btn" onClick={() => onDelete(song.id)} title="Удалить">🗑</button>
        )}
      </div>
    </div>
  );
}
